'use client'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/shadcn/dialog'
import { Button } from '@/components/ui/shadcn/button'
import { Separator } from '@/components/ui/shadcn/separator'

export default function ConfirmModal({
  open,
  setOpen,
  title,
  description,
  acceptButtonText,
  onAccept,
  loading,
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={v => {
        if (!v) setOpen(false)
      }}
    >
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <Separator />
        <DialogFooter className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button variant="outline" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onAccept}
            disabled={loading}
            id="confirm-button"
          >
            {acceptButtonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
